import React, { useState, useEffect } from "react";
import "../../Table/Table.css";
import axios from "axios";
import { format } from "date-fns";
import { config } from "./../../../confi";
import { SearchOutlined } from "@ant-design/icons";
import Spinner from "../../Loader/Spinner";
import formatDate from "./../../../Utilitys"

function Table__display() {
  let [Data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [from_date,Setfrom_date] = useState('')
  const [To_date,SetTo_date] = useState('')
  const [select_option,Setselect_option] = useState('')
  const [Limit,Setlimit]  = useState(10)

  const [loading, setLoading] = useState(false);
  const [msg, setmsg] = useState(false);

//----------------input change handler -------------//


 const input_change_handler = (e) =>{
 
   if(e.target.name ==="date_select"){
    Setfrom_date(e.target.value)

   }
   
   if(e.target.name ==="date_select2"){
    SetTo_date(e.target.value)

   }

   if(e.target.name ==="search-19"){
setSearch(e.target.value)
   }

   if(e.target.name ==='select_option'){
    Setselect_option(e.target.value)
   }


   if(e.target.name === "limit-select"){


    Setlimit(e.target.value)
  }
  


 }


//--------------------search by data and recient no -----------------//

const buttonclick_handler = () =>{
setCurrentPage(1)
FetchHandler()

}
//--------------------------------------//








  ////--------  data fetch function  ---------////

  async function FetchHandler() {
    let reqbody = JSON.stringify({
      fn: "common_fun",
      an: "fn_fe_di_re",
      payload: { page: currentPage,search:search,from_date:from_date,to_date:To_date,order:select_option,limit:Limit },
    });

    try {
      setLoading(true);

      const response = await axios.post(
        `${config.apiBaseURL}/root`,
        { data: reqbody },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      // console.log(response);

      if (response.status === 200 && response.data.status === "0") {
        setData(response.data.data);
      } else {
      }
    } catch (error) {}
    setLoading(false);
  }

  //-----------------//////////////
  useEffect(() => {
    FetchHandler();
  }, [currentPage,select_option,Limit]);

  return (
    <div className="my-table">
      <div>
        {loading ? (
          <span style={{ textAlign: "center" }}>
            {" "}
            <Spinner />
          </span>
        ) : (
          <div>
            <div className="div-for-search">
              <p>Display Date Report</p>
              <div className="serchdiv">
                <input placeholder="Rec.no" type ="text" name ="search-19" value={search} onChange={input_change_handler} ></input>
                <button className="searchbtn2" onClick={buttonclick_handler}><SearchOutlined /></button>
                <label> From</label>
               <input type="date" name='date_select' value={from_date} onChange={input_change_handler}></input>
               <label> To</label>
               <input type="date" name='date_select2' value={To_date} onChange={input_change_handler}></input>
               <button className="searchbtn2" onClick={buttonclick_handler}><SearchOutlined /></button>
               <select value={select_option} name="select_option" onChange={input_change_handler}>
      <option value="">All</option>
      <option value="dis_date desc">Descending</option>
      <option value="dis_date asc">Ascending</option>
      <option value="t_book_date.created_at desc">New</option>
    </select>
              </div>
            </div>
            <table className="my-table-main">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Member Rec. No.</th>

                  <th>Mobile No.</th>
                  <th>Display name</th>
                  <th>Display Date</th>
                </tr>
              </thead>
              {Data.length > 0 ? (
                <tbody>
                  {Data.map((e, i) => {
                    return (
                    
                        <tr key={i+741}>
                          <td>{e.name_person}</td>
                          <td>{e.membership_rec_no}</td>
                          <td>{e.mobile_no}</td>
                          <td>{e.dis_name}</td>

                          <td>{formatDate(e.dis_date)}</td>
                        </tr>
                  
                    );
                  })}
                </tbody>
              ) : (
                <span style={{ textAlign: "center", display: "inline-block" }}>
                  {" "}
                  No Record
                </span>
              )}
            </table>

            <div style={{ marginTop: "5px", textAlign: "center" }}>
              <button
                className={`${
                  currentPage === 1
                    ? "pagination-btn-disabled"
                    : "pagination-btn "
                }`}
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span className="Page-text">Page {currentPage}</span>
              <button
                className={`${
                  Data.length < 10
                    ? "pagination-btn-disabled"
                    : "pagination-btn "
                }`}
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage < 1 || Data.length < 10}
              >
                Next
              </button>
              <select className="limit-input" placeholder="Select Limit" name ="limit-select" value={Limit} onChange={input_change_handler}>
                  <option  value="10">10</option>
                  <option  value="20">20</option>
                  <option  value="50">50</option>
                  <option  value="100">100</option>
                </select>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Table__display;
